import PropTypes from 'prop-types';
import React from 'react';

import MomentPropTypes from "../../../helpers/MomentPropTypes";
import { translate as t } from '../../../lib/I18n';

function Validity({ type, from, to }) {
    if (!from || !to) { return null; }
    const dateFormat = 'ddd DD MMM YYYY';
    const isSame = from.isSame(to, 'day');

    return (
        <li>
            <span className="fix-width">
                { t(`booking.fares.details.dates.${type}`) }
            </span>

            <span className="text-weight--normal">
                { t('booking.fares.details.dates.period', {
                    from: from.format(dateFormat),
                    until: to.format(dateFormat),
                    showRange: isSame ? 0 : 1
                }) }
            </span>
        </li>
    );
}

Validity.propTypes = {
    type: PropTypes.string.isRequired,
    from: MomentPropTypes.isMoment,
    to: MomentPropTypes.isMoment
};

export default Validity;



// WEBPACK FOOTER //
// ./src/components/fares/details/Validity.js